<template>
  <div>
    <v-app-bar
      color="transparent"
      data-peterson-colors="#32a8e4e6, #799495"
      short
      max-height="56px"
      class="mt-4 mb-8 px-0 elevation-0 bar"
    >
      <v-toolbar-title class="mr-4 text-subtitle-1 text-sm-h5">
        <v-avatar color="primary mr-2">
          <v-icon large color="white">{{ headerIcon }}</v-icon>
        </v-avatar>
        <span class="primary--text font-weight-bold header-title text-h4">{{
          headerText
        }}</span>
      </v-toolbar-title>

      <slot></slot>

      <v-spacer></v-spacer>

      <span>
        <div class="text-center">
          <v-menu left bottom :disabled="!enableSiteSelect">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="tertiary" dark v-bind="{ attrs }" v-on="on">
                {{ activeSite }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in selectableSites"
                :key="index"
                @click="setActiveSite(item)"
              >
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </span>
    </v-app-bar>
  </div>
</template>

<script scoped>
import { mapState, mapGetters } from 'vuex';
import ResponsiveSizeHelperMixin from '@/mixins/ResponsiveSizeHelperMixin';

export default {
  mixins: [ResponsiveSizeHelperMixin],
  props: {
    headerText: {
      default: '',
      type: String,
    },
    headerIcon: {
      default: '',
      type: String,
    },
    doShowActiveSiteLabel: {
      default: true,
      type: Boolean,
    },
    disableSiteChange: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState(['userStore']),
    ...mapGetters({
      getUser: 'userStore/getUser',
      getActiveSite: 'userStore/getActiveSite',
      nonActiveSites: 'userStore/nonActiveSites',
      isClientConnectedToServer: 'userStore/isClientConnectedToServer',
    }),
    activeSiteLogo() {
      const site = this.getActiveSite;
      if (!site) {
        return null;
      }
      return site.logo;
    },
    activeSite() {
      const site = this.getActiveSite;
      if (!site) {
        return null;
      }
      return site.name;
    },
    assignedSites() {
      return this.getUser.assignedSites;
    },
    assignedSitesNames() {
      return this.assignedSites.map((x) => x.name);
    },
    selectableSites() {
      return this.nonActiveSites;
    },
    selectableSitesNames() {
      return this.nonActiveSites.map((x) => x.name);
    },
    userHasNonActiveSites() {
      return this.nonActiveSites && this.nonActiveSites.length > 0;
    },
    enableSiteSelect() {
      return this.userHasNonActiveSites
        && !this.disableSiteChange
        && this.isClientConnectedToServer;
    },
  },
  methods: {
    setActiveSite(site) {
      this.$store.dispatch('userStore/setActiveSite', site);
    },
  },
  created() {
    this.activeSiteDisplayed = this.activeSite;
  },
};
</script>

<style scoped>
img.rounded-corners {
  border-radius: 3px;
}

.header-title {
  display: inline-block;
  vertical-align: middle;
}

div >>> .v-toolbar__content {
  padding: 4px 0px !important;
}
</style>
